export default __webpack_public_path__ + "static/media/dash_icon.5b45ff95.svg";